import { DefaultLayout } from 'core/layouts';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { useTemplateQueryContext } from 'modules/templateEditor/context/TemplateQueryContext';
import styled from 'styled-components';
import { WarningBanner } from 'ui/banner';
import { spacing } from 'ui/theme';
import { usePlacementSelectorContext } from 'modules/placements/context/PlacementSelectorContext';
import {
  DetailsEditSaveButton,
  EditableHeader,
  EditorContentContainer,
  ErrorWarningBanner,
  LayoutContentContainer,
  SettingsAndCreatorWrapper,
  SettingsContainer,
  SettingsCreatorAndModifierSection,
  SettingsHeader,
  SettingsWrapper,
  getMediumDataContentId,
} from '../../common';
import { DISPLAY_CONTENT } from '../constants';
import { PreviewPane } from '../preview/PreviewPane';
import { SettingsForm } from './SettingsForm';

const StyledWarningBanner = styled(WarningBanner)`
  margin-top: ${spacing.plusHalf};
`;

const { detailsHeader } = DISPLAY_CONTENT.settings;

export const SettingsEditorCore = () => {
  const { medium } = useTemplateQueryContext();
  const { isEditMode, liveTemplate } = useEditableFieldsContext();
  const contentId = getMediumDataContentId(medium, liveTemplate);

  return (
    <EditorContentContainer>
      <SettingsAndCreatorWrapper>
        <SettingsContainer data-test="template-editor-embedded-settings" isEditMode={isEditMode}>
          <SettingsWrapper>
            <SettingsHeader>
              {detailsHeader}
              <DetailsEditSaveButton />
            </SettingsHeader>
            <ErrorWarningBanner />
            <SettingsForm key={contentId} />
          </SettingsWrapper>
        </SettingsContainer>
        <SettingsCreatorAndModifierSection />
      </SettingsAndCreatorWrapper>
      <PreviewPane />
    </EditorContentContainer>
  );
};

export const Settings = () => {
  const { selectedPlacementDetails, isSelectedPlacementArchived } = usePlacementSelectorContext();

  const warningBannerContent = (
    <>
      Placement <strong>{selectedPlacementDetails?.placementName}</strong> has been archived.
      Template cannot be used in new campaigns. Create a new template with an active placement.
    </>
  );

  return (
    <DefaultLayout>
      <LayoutContentContainer data-test="embedded-template-settings">
        <EditableHeader />
        {isSelectedPlacementArchived && (
          <StyledWarningBanner data-test="archived-placement-warning-banner">
            {warningBannerContent}
          </StyledWarningBanner>
        )}
        <SettingsEditorCore />
      </LayoutContentContainer>
    </DefaultLayout>
  );
};

export default Settings;
